import { useMemo } from "react";
import { AssetLibrary as SharedAssetLibrary } from "@proof/authoring";
import { assetLibraryServices } from "@proof/sdk";
import type { Project } from "@proof/core";
import { useWorkspaceTransport } from "./WorkspaceContext";
export function AssetLibrary({
  project,
  hasDocument = true,
  onChange,
  notify,
}: {
  project: Project;
  hasDocument?: boolean;
  onChange(project: Project): void;
  notify(message: string): void;
}) {
  const transport = useWorkspaceTransport();
  const services = useMemo(
    () =>
      assetLibraryServices(
        transport.client,
        hasDocument ? project.id : undefined,
      ),
    [transport.client, hasDocument, project.id],
  );
  return (
    <SharedAssetLibrary
      tenantId={project.tenantId}
      project={hasDocument ? project : undefined}
      services={services}
      canApply={hasDocument && transport.can("tenant.documents.manage")}
      canUpload={transport.can("tenant.assets.manage")}
      initialScope={hasDocument ? "project" : "shared"}
      onChange={onChange}
      notify={notify}
    />
  );
}
